export const LOCK_ERROR_KEYS = ['resource_locked', 'lock_unavailable']

const LOCK_MESSAGES = {
  resource_locked: 'This resource is being updated elsewhere. Please try again in a moment.',
  lock_unavailable: 'Unable to complete this action right now. Please try again.',
}

const matchesLockKey = (value) => {
  if (typeof value !== 'string') return null
  const normalized = value.toLowerCase()
  return LOCK_ERROR_KEYS.find((key) => normalized.includes(key)) ?? null
}

const getErrorCode = (error) => error?.code ?? error?.error?.code

const getErrorMessage = (error) =>
  error?.message ?? error?.error?.message ?? error?.error?.key ?? error?.key

export const getResourceLockKind = (error) => {
  if (!error) return null

  const code = getErrorCode(error)
  const keyMatch = matchesLockKey(error?.key)
  const messageMatch = matchesLockKey(getErrorMessage(error))

  if (code === 409 || keyMatch || messageMatch) {
    return keyMatch ?? messageMatch ?? 'resource_locked'
  }

  return null
}

export const isResourceLockError = (error) => getResourceLockKind(error) !== null

export const getCallableErrorMessage = (error, { fallbackMessage } = {}) => {
  const lockKind = getResourceLockKind(error)
  if (lockKind) {
    const apiMessage = getErrorMessage(error)
    if (apiMessage && !matchesLockKey(apiMessage)) {
      return apiMessage
    }
    return LOCK_MESSAGES[lockKind]
  }

  const apiMessage = getErrorMessage(error)
  if (apiMessage) return apiMessage

  return fallbackMessage ?? 'Something went wrong. Please try again.'
}
